// extracted by mini-css-extract-plugin
export default {"wrapper":"_3nOeomV8IY","flex-wrapper":"ggTNMMfhH7","flexWrapper":"ggTNMMfhH7","full-view-error":"_1ZJSTjsg5m","fullViewError":"_1ZJSTjsg5m","full-view-error-header":"_36MdQ8DE5c","fullViewErrorHeader":"_36MdQ8DE5c","full-view-error-sub":"_2-prJbdGXu","fullViewErrorSub":"_2-prJbdGXu"};
    if(module.hot) {
      // 1625219386192
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  